import dayjs from "dayjs";
import PdfHeader from "../../../../components/pafHeader";
import { formatPhoneNumber } from "../../../../utils/appUtils";

const AllRequestReport = ({ data, date, selectedMonth, selectedMonthString }) => {
    const requestData = (data && Array.isArray(data) && data.length > 0) ? data : [];

    const getSpecializations = (specs) => {
        if (Array.isArray(specs)) {
            return specs.join(", ");
        }
        return specs || 'Nil';
    };

    const getLawyerName = (record) => {
        if (record?.firstName && record?.lastName) {
            return `${record?.salutation} ${record.firstName} ${record.lastName}`;
        }
        return record?.firstName || 'Nil';
    };

    return (
        <div>
            <div className="report-container" style={{ padding: 0, margin: 0, border: "1px solid var(--Headings-text, #005D60)", minHeight: "252mm" }}>
                <PdfHeader pdfName="Requested Lawyer" />
                <div className="total-details flexible">
                    {
                        (date?.fromDate && date?.toDate) &&<div>
                        <h4 className="information-title">Date</h4>
                        <p style={{ margin: 0, padding: "10px 0px" }}>
                            {date?.fromDate && date?.toDate
                                ? `${dayjs(date?.fromDate).format("DD-MM-YYYY")} - ${dayjs(date?.toDate).format("DD-MM-YYYY")}`
                                : "Nil"
                            }
                        </p>
                    </div>
                    }
                    {
                        selectedMonth && <>{
                            <div>
                                <h4 className="information-title">Month</h4>
                                <p style={{ margin: 0, padding: "10px 0px" }}>{dayjs(selectedMonth).format("MMMM YYYY")}</p>
                            </div>
                        }</>
                    }
                    <div>
                        <h3 className="information-title">Advocate's</h3>
                        <h2 className="information-detail">{requestData?.length}</h2>
                    </div>
                </div>
                <table className="report-table">
                    <thead>
                        <tr>
                            <th colSpan={1}>SNo</th>
                            <th colSpan={3}>Advocate Name / Bar Council Id</th>
                            <th colSpan={3}>Contact Info</th>
                            <th colSpan={2}>Specialization</th>
                            <th colSpan={2}>exp of law</th>
                            <th colSpan={2}>Qualifications</th>
                            <th colSpan={3}>About</th>
                        </tr>
                    </thead>
                    <tbody>
                        {requestData?.map((detail, index) => (
                            <tr key={detail?.id || detail?.key || index}>
                                <td colSpan={1}>{index + 1}</td>
                                <td colSpan={3}>
                                    {getLawyerName(detail)}
                                    <br />
                                    <small>{detail?.barCouncilId || "Nil"}</small>
                                </td>
                                <td colSpan={3}>
                                    {detail?.mobileNumber ? formatPhoneNumber(detail?.mobileNumber) : "Nil"}
                                    <br />
                                    <small>{detail?.email || "Nil"}</small>
                                </td>
                                <td colSpan={2}>{getSpecializations(detail?.specialization)}</td>
                                <td colSpan={2}>{detail?.experience || "Nil"}</td>
                                <td colSpan={2}>{detail?.qualification || "Nil"}</td>
                                <td colSpan={3}>{detail?.aboutAs || "Nil"}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AllRequestReport;